import { render } from "./PlantForm.vue?vue&type=template&id=8d01b0aa&ts=true"
import script from "./PlantForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlantForm.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/plant/PlantForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d01b0aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d01b0aa', __exports__)) {
    api.reload('8d01b0aa', __exports__)
  }
  
  module.hot.accept("./PlantForm.vue?vue&type=template&id=8d01b0aa&ts=true", () => {
    api.rerender('8d01b0aa', render)
  })

}


export default __exports__